// ============================================================
// services/asistenciaDiariaService.ts
// Endpoints del módulo de asistencia diaria (entrada al colegio).
// ============================================================

import { httpClient } from 'utils/httpClient';
import {
  AsistenciaDiariaResponse,
  MarcarAsistenciaDiariaPayload,
  JustificarAsistenciaDiariaPayload,
  ActualizarAsistenciaDiariaPayload,
} from 'types/asistenciaDiaria.types';

export const asistenciaDiariaService = {

  // POST /asistencias-diarias/marcar — registro vía DNI (modo portería)
  // Roles: AUXILIAR, SECRETARIA, DIRECTOR, ADMIN
  async marcar(payload: MarcarAsistenciaDiariaPayload): Promise<AsistenciaDiariaResponse> {
    return httpClient.post<AsistenciaDiariaResponse>('/asistencias-diarias/marcar', payload);
  },

  // GET /asistencias-diarias?fecha=YYYY-MM-DD — listado del día
  async listarPorFecha(fecha: string, signal?: AbortSignal): Promise<AsistenciaDiariaResponse[]> {
    const data = await httpClient.get<AsistenciaDiariaResponse[]>(
      `/asistencias-diarias?fecha=${encodeURIComponent(fecha)}`,
      signal ? { signal } : undefined,
    );
    return Array.isArray(data) ? data : [];
  },

  // GET /asistencias-diarias/matricula/{matriculaId}?desde=&hasta= — historial del estudiante
  async listarPorMatricula(
    matriculaId: number,
    desde:       string,
    hasta:       string,
    signal?:     AbortSignal,
  ): Promise<AsistenciaDiariaResponse[]> {
    const q = new URLSearchParams({ desde, hasta });
    const data = await httpClient.get<AsistenciaDiariaResponse[]>(
      `/asistencias-diarias/matricula/${matriculaId}?${q}`,
      signal ? { signal } : undefined,
    );
    return Array.isArray(data) ? data : [];
  },

  // PUT /asistencias-diarias/{id}/justificar — convierte ausencia/tardanza en JUSTIFICADO
  async justificar(id: number, payload: JustificarAsistenciaDiariaPayload): Promise<AsistenciaDiariaResponse> {
    return httpClient.put<AsistenciaDiariaResponse>(`/asistencias-diarias/${id}/justificar`, payload);
  },

  // PUT /asistencias-diarias/{id} — corrección manual completa
  async actualizar(id: number, payload: ActualizarAsistenciaDiariaPayload): Promise<AsistenciaDiariaResponse> {
    return httpClient.put<AsistenciaDiariaResponse>(`/asistencias-diarias/${id}`, payload);
  },
};
